<template>
  <div class="routerContent">
    <el-row class="search-row" type="flex" justify="start" align="top">
      <el-col :span="24">
        <div class="card df p10">
          <el-form
            :model="searchForm"
            label-width="100px"
            label-position="right"
            ref="searchForm"
            size="mini"
          >
            <el-row gutter="16">
              <el-col :span="6">
                <el-form-item label="发票号码">
                  <el-input
                    v-model="searchForm.fpNumber"
                    placeholder="请输入发票号码"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="名称">
                  <el-input
                    v-model="searchForm.gfName"
                    placeholder="请输入名称"
                    clearable
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="开票日期">
                  <el-date-picker
                    v-model="searchForm.kpRq"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    style="width: 100%"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="6" class="search-btns">
                <el-form-item label="">
                  <el-button type="primary" @click="getData('refresh')">查询</el-button>
                  <el-button type="primary" @click="reset">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-col>
    </el-row>
    <el-row class="list-row" type="flex" justify="start" align="top">
      <el-col :span="24" class="list-col">
        <div class="list-scroll-area">
          <jh-table
            class="fg1 ova"
            size="small"
            :stripe="true"
            row-key="fpid"
            ref="jhTable"
            :columnList="allColumnList"
            :data="dataList"
            :height="tableHeight"
            @selection-change="handleSelectionChange"
          />
        </div>
      </el-col>
    </el-row>
    <div class="footer-bar">
      <div class="pager-container">
        <jh-pager :pager.sync="pager" @getData="getData" />
      </div>
      <div class="buttons-container">
        <el-button type="primary" :disabled="selectList.length === 0" @click="confirmSelection"
          >确定</el-button
        >
        <el-button class="ml20" @click="cancelSelection">取消</el-button>
      </div>
    </div>
    <!-- selectColumnDialog 组件未找到，如需可后续补充 -->
  </div>
</template>

<script>
export default {
  name: 'FpList',
  props: {
    // 已选择的发票ID列表，用于过滤掉已选择的发票
    selectedFpIds: {
      type: Array,
      default: () => []
    },
    // 初始选中的发票列表
    initialSelectedInvoices: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchForm: {
        fpNumber: '',
        fpType: '',
        gfName: '',
        kpRq: [],
        qrStatus: '01'
      },
      pager: {
        size: 50,
        total: 0,
        page: 1
      },
      dataList: [], //表格数据
      selectList: [], //选中数组
      showSelect: false, //表格动态列
      selectCol: [], //选中列
      importDialogVisible: false,
      travelDialogVisible: false, //行程单弹窗
      currentFpid: '', //当前选中的发票ID
      excludedFpIds: [], // 需要排除的发票ID数组
      tableHeight: 400, // 表格高度，用于固定表头
      //表格列数组  不是用动态列可以直接赋值给columnList 不需要computed
      allColumnList: [
        {
          type: 'selection',
          align: 'center',
          reserveSelection: true //与表格的row-key配合使用 实现跨页选中
        },
        {
          type: 'index',
          align: 'center'
        },
        {
          prop: 'fpCatName',
          label: '发票种类',
          align: 'center',
          minWidth: '100px'
        },
        {
          prop: 'fpNumber',
          label: '发票号码',
          align: 'left',
          minWidth: '120px'
        },
        {
          prop: 'fpTypeName',
          label: '发票类型',
          align: 'center',
          minWidth: '100px'
        },
        {
          prop: 'kpRq',
          label: '开票日期',
          align: 'center',
          minWidth: '110px',
          render: (h, scope) => {
            return h('span', {}, this.formatDate(scope.row.kpRq));
          }
        },
        {
          prop: 'amtSum',
          label: '发票金额',
          align: 'right',
          width: '110px',
          sortable: true
        },
        {
          prop: 'xfName',
          label: '销方名称',
          align: 'center',
          minWidth: '120px'
        },
        {
          prop: 'remark',
          label: '备注',
          align: 'center',
          sortable: true,
          minWidth: '120px'
        }
      ]
    };
  },
  computed: {
    columnList: function () {
      return this.allColumnList.filter(
        (item) => !item.label || this.selectCol.includes(item.label) || item.label === '操作'
      );
    }
  },
  created() {
    this.selectCol = this.allColumnList
      .map((item) => item.label)
      .filter((item) => item && item != '操作');
  },
  mounted() {
    this.getData();
    // 如果有初始选中的发票，设置为选中状态
    if (this.initialSelectedInvoices && this.initialSelectedInvoices.length > 0) {
      this.selectList = [...this.initialSelectedInvoices];
    }
    // // 计算表格高度
    this.calculateTableHeight();
    // 监听窗口大小变化
    window.addEventListener('resize', this.calculateTableHeight);
  },
  activated() {
    // 当组件被激活时（弹窗打开），根据initialSelectedInvoices设置选择状态
    if (this.initialSelectedInvoices && this.initialSelectedInvoices.length > 0) {
      this.selectList = [...this.initialSelectedInvoices];
    } else {
      // 如果没有初始选中的发票，清空选择状态
      this.selectList = [];
      // 清空表格选择状态
      this.$nextTick(() => {
        if (this.$refs.jhTable && this.$refs.jhTable.clearSelection) {
          this.$refs.jhTable.clearSelection();
        }
      });
    }
  },
  watch: {
    // 监听已选择的发票ID变化，重新加载数据
    selectedFpIds: {
      handler(newVal) {
        this.excludedFpIds = newVal || [];
        this.getData('refresh');
      },
      immediate: true
    },
    // 监听初始选中的发票变化
    initialSelectedInvoices: {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.selectList = [...newVal];
        }
      },
      immediate: true
    }
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectList = selection;
    },
    confirmSelection() {
      // 返回当前选择的发票数据（包括已有的和新选择的）
      this.$emit('confirm', this.selectList);
      console.log('确认选择的发票:', this.selectList);
    },
    getData(type) {
      if (type === 'refresh') {
        this.pager.page = 1;
        // 不再清空选择状态，保留当前选中的发票
      }

      const params = {
        pageNum: this.pager.page,
        pageSize: this.pager.size,
        fpNumber: this.searchForm.fpNumber,
        fpType: this.searchForm.fpType,
        gfName: this.searchForm.gfName,
        fpStatus: this.searchForm.fpStatus || '1',
        qrStatus: this.searchForm.qrStatus || '01'
      };

      // 处理日期范围
      if (this.searchForm.kpRq && this.searchForm.kpRq.length === 2) {
        params.startDate = this.searchForm.kpRq[0];
        params.endDate = this.searchForm.kpRq[1];
      }
      if (this.excludedFpIds) {
        params.excludedFpIds = this.excludedFpIds;
      }

      this.$api.formPost('/api/major/fpgl/doGetList', params).then((res) => {
        if (res.retHead && res.retHead.code === '0000000') {
          this.dataList = res.retBody.list || [];

          this.pager.total = res.retBody.total || 0;
          this.$nextTick(() => {
            if (this.$refs.jhTable && this.$refs.jhTable.doLayout) {
              this.$refs.jhTable.doLayout();
            }
          });
        }
      });
    },
    reset() {
      this.$refs.searchForm.resetFields();
      this.searchForm = {
        fpNumber: '',
        fpType: '',
        gfName: '',
        kpRq: []
      };
      // 清空选择状态
      this.selectList = [];
      // 清空表格选择状态
      this.$nextTick(() => {
        if (this.$refs.jhTable && this.$refs.jhTable.clearSelection) {
          this.$refs.jhTable.clearSelection();
        }
      });
      this.getData('refresh');
    },
    setExcludedFpIds(ids) {
      this.excludedFpIds = ids || [];
      this.getData('refresh');
    },
    cancelSelection() {
      // 取消选择，关闭弹窗
      this.$emit('cancel');
    },
    formatDate(dateStr) {
      if (!dateStr) return '';
      // 处理日期格式 "2025-01-07 00:00:00" -> "2025-01-07"
      return dateStr.split(' ')[0];
    },
    // 计算表格高度
    calculateTableHeight() {
      this.$nextTick(() => {
        const container = this.$el;
        if (container) {
          const searchRow = container.querySelector('.search-row');
          const footerBar = container.querySelector('.footer-bar');
          const containerHeight = container.clientHeight;
          const searchHeight = searchRow ? searchRow.offsetHeight : 0;
          const footerHeight = footerBar ? footerBar.offsetHeight : 0;
          // 预留一些边距和间距
          const padding = 10;
          this.tableHeight = containerHeight - searchHeight - footerHeight - padding;
          // 最小高度限制
          if (this.tableHeight < 200) {
            this.tableHeight = 200;
          }
        }
      });
    }
  },
  // 组件销毁时移除事件监听
  beforeDestroy() {
    window.removeEventListener('resize', this.calculateTableHeight);
  }
};
</script>

<style lang="scss" scoped>
.routerContent {
  min-height: 600px;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}

.search-row {
  flex-shrink: 0;
}

.card {
  margin-bottom: 0;
  // 保证表单区域不会被压缩
}

.list-row {
  flex: 1 1 auto;
  min-height: 0;
  height: 0;
}

.list-col {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.list-scroll-area {
  flex: 1 1 auto;
  min-height: 200px;
  background: #fff;
  border-radius: 4px;
  margin: 10px 0;
  // 移除overflow-y: auto，让表格组件自己处理滚动
}

.footer-bar {
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 10;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  border-top: 1px solid #f0f0f0;
}

.pager-container {
  flex: 1;
  display: flex;
  justify-content: center;
}

.buttons-container {
  display: flex;
  justify-content: flex-end;
}

.df {
  display: flex;
}

.fdc {
  flex-direction: column;
}

.ova {
  overflow: auto;
}

.el-dialog {
  min-width: 400px !important;
  min-height: 200px !important;
  // 你可以根据实际情况调整
}

.search-btns {
  display: flex;
  align-items: center;
  height: 100%;
}
</style>
